// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Hero Entry
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

var heroSection = ".hero-section";


function heroEntry(showMarkers, heroSection) {

  var taglines = heroSection.querySelectorAll(".tagline");
  var heroText = heroSection.querySelector(".text");
  var heroLink = heroSection.querySelector(".hero-link");
  var heroImg = heroSection.querySelector(".hero-img");

  const heroEntry = gsap.timeline({
    paused: "true",
    scrollTrigger: {
      trigger: heroSection,
      start: "top center",
      //toggleActions: "play pause resume resume",
      toggleActions: "play pause resume reverse",
      id: "hero",
      pinReparent: true,
      markers: showMarkers,
    },
  });


  // Animate main heading up

  if(taglines){
    taglines.forEach((tagline, i) => {
      gsap.set(tagline, {y: 48, opacity: 0})
      heroEntry.to(tagline, {y: 0, opacity: 1, duration: 1.5}, 0);
    });
  }


  // Animate extra text up, slight later (on homepage only)

  if(heroText){
    gsap.set(heroText, {y: 48, opacity: 0})
    heroEntry.to(heroText, {y: 0, opacity: 1, duration: 1.5, delay: .5}, 0);
  }  


  // Animate career item link (on homepage only)

  if(heroLink){
    gsap.set(heroLink, {x: 48, opacity: 0})
    heroEntry.to(heroLink,{x: 0, opacity: 1, duration: 1.5}, 0);
  }


  // Animate image
  gsap.set(heroImg, { scale: 1.3, opacity: 0, transformOrigin: "50% 50%" });
  heroEntry.to(heroImg,{scale: 1, opacity: 1, duration: 1.2}, 0);

}

export { heroEntry };
